import { ClockIcon } from '@heroicons/react/24/outline';
import { formatTime } from '@odo/shared-ui';

interface AppointmentTimeDisplayProps {
    time: string | null;
}

/** Read-only counterpart of the dashboard Composer's TimeField select —
 *  same icon + label, no interaction. */
export function AppointmentTimeDisplay({ time }: AppointmentTimeDisplayProps) {
    return (
        <div className="w-full flex items-center gap-2 rounded-lg border border-gray-200 bg-white px-3 py-2.5 text-sm text-gray-800">
            <ClockIcon className="h-4 w-4 text-gray-400 shrink-0" />
            <span className="flex-1 truncate">{formatTime(time) || 'No time set'}</span>
        </div>
    );
}
